import React, { useContext, useEffect } from 'react';
import { Highlight, useHits, useInstantSearch } from 'react-instantsearch';
import ContentLoader from 'react-content-loader';
import GtmContext from '../../contexts/GtmContext';
import { baseConfig } from '../../config/algolia';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { useFeatureFlag } from '../../hooks/useFeatureFlag/useFeatureFlag';

const { product_families_index } = baseConfig;

export const KeywordSuggestions = ({ onSearch, priceRange, saleItems }) => {
  const { results: searchResults } = useHits();
  const { status } = useInstantSearch();
  const isSearchStalled = status === 'stalled';
  const searching = status === 'loading';
  const { gtm, setGtm } = useContext(GtmContext);
  const hits = searchResults && searchResults.hits;
  const hasResults = searchResults && searchResults.nbHits !== 0;
  const noResults = searchResults && searchResults.nbHits === 0 && !searching && !isSearchStalled;
  const isDesktop = useBreakpoint('md', 'up');
  const isNewSearch = useFeatureFlag('isSearchOverlayNewDesign');
  const keywordsLimitDesktop = isNewSearch ? 6 : 10;
  const keywordsLimitMobile = isNewSearch ? 6 : 5;
  const keywordsLimit = isDesktop ? keywordsLimitDesktop : keywordsLimitMobile;

  useEffect(() => {
    if (hasResults) {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          keywords: hits.slice(0, keywordsLimit).map((c, i) => ({
            label: c.query,
            position: i + 1,
          })),
        },
      });
    } else {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          keywords: undefined,
        },
      });
    }
  }, [hasResults]);

  /**
   * Event handler to trigger search on keyword click
   */
  const onSelectKeyword = (e, term) => {
    e.preventDefault();
    onSearch(term, 'click suggested keyword', priceRange, saleItems);
  };

  const clickGtmHandler = (e, hit, i) => {
    window.dataLayer.push({
      ...gtm,
      event: 'custom.search.suggested.click',
      label: hit.query,
      suggestions: {},
      suggestion: {
        type: 'keyword',
        label: hit.query,
        position: i + 1,
      },
      products: [],
    });
  };

  if (noResults) {
    return <div key="1">No results</div>;
  } else if (hasResults) {
    return (
      <>
        {hits.slice(0, keywordsLimit).map((hit, i) => {
          const resultNum =
            hit[product_families_index] &&
            hit[product_families_index]['facets'].exact_matches['availability.displayProduct'].find(
              v => v.value === 'true'
            )
              ? hit[product_families_index]['facets'].exact_matches['availability.displayProduct'].find(
                  v => v.value === 'true'
                ).count
              : 0;
          return (
            <li key={hit.objectID}>
              <a
                href={'/search?query=' + hit.query}
                onClick={e => {
                  onSelectKeyword(e, hit.query);
                  clickGtmHandler(e, hit, i);
                }}
              >
                <Highlight hit={hit} attribute="query" highlightedTagName="em" />
                <span className="popularity">{resultNum}</span>
              </a>
            </li>
          );
        })}
      </>
    );
  } else {
    return [...Array(keywordsLimit)].map((e, i) => (
      <ContentLoader
        key={i}
        speed={1}
        width={250}
        height={9}
        viewBox="0 0 250 9"
        backgroundColor="#ececec"
        foregroundColor="#cccccc"
      >
        <rect x="0" y="2" rx="3" ry="3" width="250" height="5" />
      </ContentLoader>
    ));
  }
};
